import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, actions } from 'react-redux-form/immutable'
import { Fieldset, Row, Field } from 'react-gridforms'
import RowSearch from 'bisu-react-row-search'
import Input from 'bisu-react-input'
import Trash from 'react-icons/lib/md/delete'

import ConfirmDialog from 'components/ConfirmDialog'
import { required, intRequired } from 'utils/validators'

const validators = {
  fee_id: { intRequired },
  amount: { required },
}

class FormFee extends Component {

  constructor(props) {
    super(props)
    this.state = {
      openConfirm: false,
    }
  }

  componentDidMount() {
    const { dispatch, item } = this.props
    if (item) {
      dispatch(actions.change('presetDetailState', item))
    } else {
      dispatch(actions.reset('presetDetailState'))
    }
  }

  _openConfirm = () => {
    this.setState({
      openConfirm: true,
    })
  }

  _closeConfirm = () => {
    this.setState({
      openConfirm: false,
    })
  }

  _onDelete = () => {
    this.props.onDelete(this.props.item)
  }

  _renderConfirm() {
    const { openConfirm } = this.state
    if (!openConfirm) {
      return null
    }

    return (
      <ConfirmDialog
        msg={`Are you sure you want to delete?`}
        closeDialog={this._closeConfirm}
        confirmAction={this._onDelete}
        btnClass="btn-danger"
      />
    )
  }

  render() {
    const { onSubmit, fees, pending, item } = this.props
    const isEdit = !!item

    return (
      <Form model="presetDetailState" className="grid-form" onSubmit={onSubmit} validators={validators}>
        <Fieldset legend="Fee Detail">
          <RowSearch
            placeholder="Search Fee Code"
            label1="Fee Code"
            label2="Fee Name"
            model="presetDetailState.fee_id"
            model1="presetDetailState.fee_code"
            model2="presetDetailState.fee_name"
            searchResults={fees}
            isOffline
            required
            autoFocus
          />
          <Row>
            <Field>
              <Input
                model=".amount"
                label="Amount (Php)"
                required
              />
            </Field>
          </Row>
        </Fieldset>
        <fieldset className="modal-footer" disabled={pending}>
          { isEdit &&
            <button onClick={this._openConfirm} type="button" className="btn btn-icon"><Trash /></button> }
          <button type="submit" className="btn btn-info">Save Fee</button>
        </fieldset>
        {this._renderConfirm()}
      </Form>
    )
  }
}

export default connect()(FormFee)



// WEBPACK FOOTER //
// ./src/containers/FeesPresets/form-fee.js